import { useEffect, useState } from 'react'

import useCurrencyState from 'app/hooks/useCurrencyState'
import { useGetViewedListings } from 'app/services/Query/listing/listing.query'

interface UseYouRecentlyViewed {
  slugs: string[]
  isMobile?: boolean
  isLargeSize?: boolean
}
export const useYouRecentlyViewed = ({
  slugs,
  isLargeSize,
  isMobile
}: UseYouRecentlyViewed) => {
  const { currency } = useCurrencyState()

  const maxCards = isMobile ? 10 : isLargeSize ? 4 : 5

  const [startIndex, setStartIndex] = useState(0)
  const endIndex = startIndex + maxCards

  const enabled = !!slugs.length && !!currency

  const {
    data: listings,
    isLoading,
    refetch
  } = useGetViewedListings({
    options: {
      enabled
    },
    params: {
      listing_slugs: slugs
    }
  })

  useEffect(() => {
    if (currency && enabled) refetch()
  }, [currency])

  const data = listings

  return {
    data,
    isLoading,
    startIndex,
    setStartIndex,
    endIndex,
    maxCards,
    currency
  }
}
